<script>
  import { slide } from "svelte/transition";
  import Dialog, {
    Title,
    Content,
    Actions,
    InitialFocus
  } from "@smui/dialog/bare.js";
  import "@smui/dialog/bare.css";

  // import BookingForm from '../../components/BookingForm.svelte';
  // import BookingFormYup from '../../components/BookingFormYup.svelte';
  import BookingFormLib from "../../components/BookingFormLib.svelte";
  // import MatBookingForm from '../../components/MatBookingForm.svelte';
  export let config = {};
  export let data = {};

  let dialogTerms;
  let dialogWaiver;
  let dialogSafety;
  let dialogPhotoRelease;

  const openHandler = e => {
    if (e.detail.type === "dialogTerms") {
      dialogTerms.open();
    } else if (e.detail.type === "dialogSafety") {
      dialogSafety.open();
    } else if (e.detail.type === "dialogWaiver") {
      dialogWaiver.open();
    } else if (e.detail.type === "dialogPhotoRelease") {
      dialogPhotoRelease.open();
    }
  };
  const closedHandler = e => {
    console.log("closedHandler", e);
  };

  let bookings = false;
  const handleBookings = () => {
    bookings = !bookings;
    console.log("bookings", bookings);
  };
</script>

<style>
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    column-gap: 80px;
    padding: 40px 0 20px;
    align-items: start;
  }
  @media screen and (min-width: 600px) and (max-width: 959px) {
    .grid {
      padding: 60px 0 30px;
    }
  }
  @media screen and (min-width: 960px) {
    .grid {
      padding: 80px 0 40px;
    }
  }
  button {
    margin-bottom: 20px;
  }
</style>

<section class={config.class} data-section="rates">
  <div class="layout grid">
    {#each data.cols as col}
      {#if col.config.tpl === 'txt'}
        <div>
          {@html col.data.html}
        </div>
      {/if}
    {/each}
    {#if data.xtras}
      <div>
        {#if data.xtras[0].config.tpl === 'booking-btn'}
          <button on:click={() => handleBookings()} data-btn="bookings">
            {data.xtras[0].data.link.label}
            {#if bookings}v{:else}>{/if}
          </button>
        {/if}
      </div>
    {/if}
  </div>

  <!-- {#if data.xtras}
    <div class="xtras">
      <div class="grid">
          {#each data.xtras as xtra, i}
            <div>
            {#if xtra.config.tpl === 'booking-btn'}
              <button on:click={() => handleBookings()}>{xtra.data.link.label} ></button>
            <!-- {:else if xtra.config.tpl === 'dialog-hs'}
              <a class="pointer" on:click={() => dialogHS.open()}>{xtra.data.link.label}</a>
            {:else if xtra.config.tpl === 'dialog-fees'}
              <a class="pointer" on:click={() => dialogFees.open()}>{xtra.data.link.label}</a>
            {:else if xtra.config.tpl === 'dialog-terms'}
              <a class="pointer" on:click={() => dialogTerms.open()}>{xtra.data.link.label}</a> -- >
            {/if}
          </div>          
          {/each}
      </div>
    </div>
    {/if} -->

  {#if bookings}
    <div class="layout" transition:slide={{ duration: 400 }}>
      <BookingFormLib on:dialog={openHandler} />
    </div>
  {/if}

</section>

<Dialog
  bind:this={dialogTerms}
  aria-labelledby="dialog-title"
  aria-describedby="dialog-content"
  on:MDCDialog:closed={closedHandler}>
  <div class="close-ctr">
    <a class="close-icon pointer" on:click={() => dialogTerms.close()}>
      <img src="./io/icons8-delete.png" alt="close" />
    </a>
  </div>
  <!-- <Title id="dialog-title">{data.xtras[2].data.title}</Title> -->
  <Content>
    <div class="dialog-content">
      {@html data.xtras[1].data.html}
    </div>
  </Content>
  <!-- <Actions>
    <button on:click={() => dialog.close()}>x</button>
  </Actions> -->
</Dialog>

<Dialog
  bind:this={dialogSafety}
  aria-labelledby="dialog-title"
  aria-describedby="dialog-content"
  on:MDCDialog:closed={closedHandler}>
  <div class="close-ctr">
    <a class="close-icon pointer" on:click={() => dialogSafety.close()}>x</a>
  </div>
  <Content>
    <div class="dialog-content">
      {@html data.xtras[2].data.html}
    </div>
  </Content>
</Dialog>

<Dialog
  bind:this={dialogWaiver}
  aria-labelledby="dialog-title"
  aria-describedby="dialog-content"
  on:MDCDialog:closed={closedHandler}>
  <div class="close-ctr">
    <a class="close-icon pointer" on:click={() => dialogWaiver.close()}>
      <img src="./io/icons8-delete.png" alt="close" />
    </a>
  </div>
  <Content>
    <div class="dialog-content">
      {@html data.xtras[3].data.html}
    </div>
  </Content>
</Dialog>

<Dialog
  bind:this={dialogPhotoRelease}
  aria-labelledby="dialog-title"
  aria-describedby="dialog-content"
  on:MDCDialog:closed={closedHandler}>
  <div class="close-ctr">
    <a class="close-icon pointer" on:click={() => dialogPhotoRelease.close()}>
      <img src="./io/icons8-delete.png" alt="close" />
    </a>
  </div>
  <Content>
    <div class="dialog-content">
      {@html data.xtras[4].data.html}
    </div>
  </Content>
</Dialog>
